<template>
  <v-alert type="error">404 Страница не найдена</v-alert>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
